import { useEffect } from 'react';

const ROBOTS_META_ATTR = 'data-stc-robots-meta';

export const useRobotsMeta = (noIndex: boolean): void => {
  useEffect(() => {
    if (!noIndex) return undefined;

    const existing = document.head.querySelector<HTMLMetaElement>(`meta[${ROBOTS_META_ATTR}]`);
    const meta = existing ?? document.createElement('meta');
    const created = !existing;

    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex, nofollow');
    meta.setAttribute(ROBOTS_META_ATTR, 'true');

    if (created) {
      document.head.appendChild(meta);
    }

    return () => {
      if (created) {
        meta.remove();
      }
    };
  }, [noIndex]);
};
